(function() {
  // Sort handler
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /**
   * Build filter URL from checked checkboxes within a specific container.
   * This prevents the duplicate-checkbox bug where mobile + desktop copies
   * of the same filter both contribute to the form submission.
   */
  function buildFilterUrl(container) {
    var base = document.getElementById('ame-filter-form');
    if (!base) return window.location.href;

    var url = new URL(base.action, window.location.origin);

    // Preserve sort_by
    var sortInput = base.querySelector('input[name="sort_by"]');
    if (sortInput && sortInput.value) {
      url.searchParams.set('sort_by', sortInput.value);
    }

    // Collect only checked checkboxes from THIS container
    var checkboxes = container.querySelectorAll('[data-filter-auto]');
    checkboxes.forEach(function(cb) {
      if (cb.checked && !cb.disabled) {
        url.searchParams.append(cb.name, cb.value);
      }
    });

    // Collect price range inputs from THIS container
    var priceInputs = container.querySelectorAll('.ame-collection__price-input');
    priceInputs.forEach(function(input) {
      if (input.value && input.name) {
        url.searchParams.set(input.name, input.value);
      }
    });

    return url.toString();
  }

  // Filter auto-submit on checkbox change — scoped to the parent container
  document.addEventListener('change', function(e) {
    if (e.target.matches('[data-filter-auto]')) {
      var container = e.target.closest('[data-filter-container]');
      if (container) {
        window.location.href = buildFilterUrl(container);
      }
    }
  });

  // Apply Filters button — use scoped URL builder instead of native form submit
  document.querySelectorAll('.ame-collection__filter-apply').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var container = btn.closest('[data-filter-container]');
      if (container) {
        window.location.href = buildFilterUrl(container);
      }
    });
  });

  // Mobile filter drawer
  var toggle = document.querySelector('[data-filter-toggle]');
  var drawer = document.getElementById('ame-filter-drawer');
  var closeBtns = document.querySelectorAll('[data-filter-close]');

  if (!toggle || !drawer) return;

  function openDrawer() {
    drawer.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    drawer.querySelector('.ame-collection__filter-close').focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    toggle.focus();
  }

  toggle.addEventListener('click', openDrawer);
  closeBtns.forEach(function(btn) { btn.addEventListener('click', closeDrawer); });

  // Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });
})();
